import React, {useEffect} from 'react';
import axios from 'axios';
import {useTranslation} from 'react-i18next';
import {CircularProgress, Dialog, DialogTitle, DialogContent} from '@material-ui/core';

import {axiosInstance} from 'utils/auth.service';

const WaitingPaymentConfirmation = ({cinemaId, filmId, paymentMethod, onSuccess}) => {
  const {t} = useTranslation();

  useEffect(() => {
    let timeout = null;
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const fetchConfirmation = () => {
      axiosInstance
        .get(`/cinemas/${cinemaId}/films/${filmId}/payment/${paymentMethod}`, {cancelToken: source.token})
        .then(res => {
          if (res.data.status === 'succeeded') {
            // TODO: change waiting status
          }
          if (res.data.payment_profile?.paid) {
            onSuccess(res.data);
            return;
          }
          timeout = setTimeout(fetchConfirmation, 1000);
        });
    };

    fetchConfirmation();
    return () => {
      source.cancel();
      // TODO: cancel waiting axios request
      if (timeout) return clearTimeout(timeout);
    };
  }, [cinemaId, filmId, paymentMethod, onSuccess]);

  return (
    <Dialog open scroll="body" className="my-dialog">
      <DialogTitle>{t('en-attente-de-confirmation-de-paiement')}</DialogTitle>
      <DialogContent>
        <CircularProgress />
      </DialogContent>
    </Dialog>
  );
};

export default WaitingPaymentConfirmation;
